module.exports = __webpack_public_path__ + "static/img/designBanner2.2d8d1a6.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/designBanner2.gif
// module id = pyAa
// module chunks = 2